var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdoorLighting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.36,11.77c-2.08,0-3.77-1.69-3.77-3.77c0-2.08,1.69-3.77,3.77-3.77c2.08,0,3.77,1.69,3.77,3.77 C9.13,10.08,7.44,11.77,5.36,11.77z M5.36,4.73C3.56,4.73,2.09,6.2,2.09,8s1.47,3.27,3.27,3.27S8.63,9.8,8.63,8 S7.17,4.73,5.36,4.73z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.23,8.87l0.62-0.05c0.03,0.25,0.1,0.45,0.2,0.61s0.27,0.29,0.5,0.38c0.22,0.1,0.48,0.15,0.76,0.15 c0.25,0,0.47-0.04,0.66-0.11c0.19-0.07,0.33-0.18,0.43-0.31c0.09-0.13,0.14-0.27,0.14-0.42c0-0.16-0.04-0.29-0.13-0.41 C13.3,8.6,13.16,8.5,12.95,8.42c-0.13-0.05-0.43-0.13-0.88-0.24c-0.45-0.11-0.77-0.21-0.95-0.31c-0.24-0.12-0.41-0.28-0.53-0.46 c-0.12-0.18-0.17-0.39-0.17-0.62c0-0.25,0.07-0.48,0.21-0.7s0.35-0.38,0.62-0.49c0.27-0.11,0.57-0.17,0.91-0.17 c0.37,0,0.69,0.06,0.97,0.18c0.28,0.12,0.49,0.29,0.65,0.52c0.15,0.23,0.23,0.49,0.24,0.78l-0.63,0.05 c-0.03-0.31-0.15-0.55-0.34-0.71c-0.19-0.16-0.48-0.24-0.86-0.24c-0.4,0-0.68,0.07-0.87,0.22c-0.18,0.14-0.27,0.32-0.27,0.52 c0,0.18,0.06,0.32,0.19,0.44c0.13,0.11,0.46,0.23,0.99,0.35s0.9,0.23,1.09,0.32c0.29,0.13,0.5,0.3,0.64,0.5 c0.14,0.2,0.21,0.44,0.21,0.7c0,0.26-0.08,0.51-0.23,0.74s-0.37,0.41-0.65,0.54c-0.28,0.13-0.6,0.19-0.95,0.19 c-0.45,0-0.82-0.06-1.12-0.2c-0.3-0.13-0.54-0.33-0.71-0.59C10.33,9.5,10.24,9.2,10.23,8.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.88,
    y: 7.75,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.0868 6.1339)",
    className: "st2",
    width: 6.96,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.09,
    y: 4.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.1256 6.131)",
    className: "st2",
    width: 0.5,
    height: 6.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorLighting);
export default __webpack_public_path__ + "static/media/OutdoorLighting.a96141e597f770abe8ba8926ab0d96f6.svg";
export { ForwardRef as ReactComponent };